import { useAppLayout } from '@/stores/appLayout'

export const updateDarkMode = () => {
  const { setDarkMode } = useAppLayout()
  if (
    localStorage.theme === 'dark' ||
    (!('theme' in localStorage) &&
      window.matchMedia('(prefers-color-scheme: dark)').matches)
  ) {
    document.documentElement.classList.add('dark')
  } else {
    document.documentElement.classList.remove('dark')
  }

  setDarkMode()
}
